<button [class]="disableButton()" type="button">
    {{text}}
</button>